import { z } from 'zod';

export const checkStatusSchema = z.enum(['ok', 'error']);

export const liveResponseSchema = z.object({ status: z.literal('ok') });

export const readyResponseSchema = z.object({
  status: z.literal('ok'),
  checks: z.object({ database: checkStatusSchema }),
});

export const notReadyResponseSchema = z.object({
  status: z.literal('unavailable'),
  checks: z.object({ database: checkStatusSchema }),
});
